module.exports = require("@cloudbase/adapter-interface");